import request from '@/utils/request' //引入封装好的 axios 请求
//银行上传
export function bankList(data) {
    return request({
        url: '/api/v1/bankLicense/selectBankLicenseList',
        method: 'post',
        data: data
    })
}

export function selectLicenseList(data) {
    return request({
        url: '/api/v1/bankLicense/selectBankLicenseList',
        method: 'post',
        data: data
    })
}
//银行上传
export function bankUpload(data) {
    return request({
        url: '/api/v1/bankLicense/uploadBankLicense',
        method: 'post',
        data: data
    })
}
//编辑详情
export function editUploadDetail(params) {
    return request({
        url: '/api/v1/bankLicense/selectBankLicenseById',
        method: 'post',
        params: params
    })
}
export function updateLicense(params) {
    return request({
        url: '/api/archive/updateLicense',
        method: 'post',
        data: params
    })
}

//编辑
export function editUploads(data) {
    return request({
        url: '/api/v1/bankLicense/updateBankLicense',
        method: 'post',
        data: data
    })
}
export function uploadBankLicense(data) {
    return request({
        url: '/api/v1/bankLicense/uploadBankLicense',
        method: 'post',
        data: data
    })
}

//删除
export function deletData(params) {
    return request({
        url: `/api/v1/bankLicense/deleteBankLicense`,
        method: 'post',
        params: params
    })
}
//删除
export function deleteBankLicense(params) {
    return request({
        url: `/api/archive/deleteBankLicense`,
        method: 'post',
        params: params
    })
}

// 信用中心通过
export function cerditCentePass(data) {
    return request({
        url: `/api/v1/bankLicense/auditBankLicense`,
        method: 'post',
        data: data
    })
}